import { OccurrenceCountFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/IndividuelleWiederholung/OccurrenceCountFormField';
import { WeekdayOccurrenceSelectFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/IndividuelleWiederholung/WeekdayOccurrenceSelectFormField';
import { DatePickerFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/DatePickerFormField';
import { RepeatIntervalSelectFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/IndividuelleWiederholung/RepeatIntervalSelectFormField';
import { WeekdaySelectFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/IndividuelleWiederholung/WeekdaySelectFormField';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { TerminWiederholungsIntervall } from '@/domain/termine/shared/types/TerminWiederholungsIntervall';
import { Card, CardContent } from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import { IndividuelleWiederholung } from '@/domain/termine/shared/types';
import { getFixedWeekday } from '@/domain/termine/shared/utils/getWeekdaySelection';
import dayjs from 'dayjs';
import { IndividuellerWiederholungsText } from '@/domain/termine/shared/utils/IndividuellerWiederholungsText';

export function IndividuelleWiederholungCard() {
  const { t } = useTranslation();
  const { form } = useCreateTermineFormContext();

  return (
    <Card className="bg-neutrals-200">
      <CardContent className="space-y-4 p-4">
        <div className="space-y-2.5">
          <p className="text-xs font-bold text-neutrals-900">
            {t('domain.termine.form.wiederholungLabel')}
          </p>

          <div className="flex flex-row gap-4">
            <OccurrenceCountFormField />
            <RepeatIntervalSelectFormField />
          </div>
        </div>
        <form.Subscribe
          selector={(state) => state.values.wiederholungsIntervall}>
          {(wiederholungsIntervall) =>
            wiederholungsIntervall === TerminWiederholungsIntervall.MONAT ||
            wiederholungsIntervall === TerminWiederholungsIntervall.JAHR ? (
              <WeekdayOccurrenceSelectFormField />
            ) : (
              wiederholungsIntervall === TerminWiederholungsIntervall.WOCHE && (
                <WeekdaySelectFormField />
              )
            )
          }
        </form.Subscribe>
        <DatePickerFormField name="wiederholungBis" />
        <div className="min-w-0">
          <form.Subscribe selector={(state) => state.values}>
            {(iw) => {
              const wiederholung: IndividuelleWiederholung = {
                occurrenceCount: iw.occurrenceCount ?? 1,
                weekDayOccurrence: iw.wochentagAuftreten,
                wochentage: iw.wochentagAuswahl
                  ? iw.wochentagAuswahl
                  : [getFixedWeekday(dayjs(iw.datum))],
                wiederholungsIntervall: iw.wiederholungsIntervall,
              };
              return (
                <div className="text-xs text-neutrals-800 font-normal">
                  <IndividuellerWiederholungsText
                    wiederholung={wiederholung}
                    wiederholungBis={iw.wiederholungBis}
                    datum={iw.datum}
                  />
                </div>
              );
            }}
          </form.Subscribe>
        </div>
      </CardContent>
    </Card>
  );
}
